import { Flex } from "antd";

export default function CertificateInfo() {
  return (
    <Flex
      align="center"
      className="p-6 bg-gradient-to-r from-gray-800 to-green-500 rounded-lg flex-col md:flex-row"
      gap={16}
    >
      <div className="flex-1">
        <h5 className="text-white text-lg lg:text-xl font-medium">
          ক্যারিয়ার সার্টিফিকেট অর্জন করুন
        </h5>

        <p className="text-white text-sm lg:text-base font-medium mt-2">
          আপনার LinkedIn প্রোফাইল, রেজুমে বা সিভিতে এই সার্টিফিকেট যুক্ত করুন।
          সামাজিক যোগাযোগমাধ্যমে শেয়ার করুন এবং পারফরম্যান্স রিভিউতে ব্যবহার
          করুন।
        </p>
      </div>
      <img
        className="md:w-52 md:h-36 w-full rounded-lg"
        src="/images/demo/users/certificates.png"
      />
    </Flex>
  );
}
